<template>
  <b-container fluid>
    <b-row>
      <b-col><h4>{{interviewDetails.title}}</h4></b-col>
    </b-row>

    <b-row v-for="(section,idx) in interviewDetails.sections" :key="idx">
      <b-col><SectionComponent :section-data="section"/></b-col>
    </b-row>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import SectionComponent from "@/views/interview/SectionComponent";

export default {
  name: 'ComplexInterviewComponent',

  props: {
    interviewDetails: Object
  },

  components: {
    SectionComponent
  },

  computed: {
    ...mapState(['activeSurvey', 'absoluteDrillPath']),
    ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),

  },

}
</script>